import React, { useEffect, useState } from "react";
import { CircularProgress, Grid } from "@mui/material";
import Product from "./Product";
import SortContext from "context/SortContext";
import { useFilter } from "context/FilterContext";
import { useLocation, useNavigate } from "react-router-dom";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import GoToTop from "components/ui/GoToTop";
import { ReactComponent as Background } from "assets/icons/bg.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import { useGlobalContext } from "context/GlobalContext";
import { formatString } from "utils/encodeDecodeStr";
import { useStockDesings } from "../api/getStockDesign";
import DataNotFound from "components/ui/datanotfound/DataNotFound";

const Products = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedSortValue, sortOptions, search } = React.useContext(SortContext);
  const selectedOption = sortOptions.find((option) => option.id == selectedSortValue);
  const { filterValues } = useFilter();
  const { setFilterChangeCount, setDisplayCount, setSearchResultCount, setFilterChangeDesignCount, dynamicfilterCount, filterChangeCount, setDynamicFilterCount } = useGlobalContext();
  const [stockData, setStockData] = useState([]);
  const categoryName = location.state?.categoryName;
  const subCategoryName = location.state?.name?.[1]?.split("-")[0]?.trim() || formatString(location.pathname.split("/").pop());
  const selectedSortBY = selectedOption?.sortBy;
  const selectedSortOrder = selectedOption?.order;

  const isHidden = filterValues && filterValues["Show Hidden Designs"];

  // Location Filter
  const Location = filterValues?.Location?.map((location) => (location === "IDL" ? "Idel Inventory" : location)) || [];

  const stockStatus = filterValues["Stock Status"]?.[0] === "On Memo" ? "Memo" : filterValues["Stock Status"]?.[0] || "";

  // Gold Color Filter
  const goldColorMapping = {
    "Yellow Gold": "Yellow",
    "Rose Gold": "Pink",
    "White Gold": "White",
  };
  const goldColor = filterValues?.["Gold Color"]?.map((color) => goldColorMapping[color]) || [];

  // Gold Purity
  const goldPurity = filterValues?.["Gold Purity"];

  // Diamond Quality
  const diamondQualityMapping = {
    "VVS-EF": "VVSEF",
    "VVS-FG": "VVSFG",
    "VVS-GH": "VVSGH",
    "VSSI-GH": "VSSIGH",
    "VS-GH": "VSGH",
    "SI-IJ": "SIIJ",
    "SI-HI": "SIHI",
  };
  const diamondQuality = filterValues?.["Diamond Quality"]?.map((qlty) => diamondQualityMapping[qlty]) || [];

  // Design Class
  const designClass = filterValues?.Class;

  // Slider Filters
  const diamondPieces = filterValues?.["Diamond Pieces"]?.length > 0 ? filterValues["Diamond Pieces"] : "";
  const diamondWeight = filterValues?.["Diamond Weight"]?.length > 0 ? filterValues["Diamond Weight"] : "";
  const goldGrossWeight = filterValues?.["Gold Gross-Weight"]?.length > 0 ? filterValues["Gold Gross-Weight"] : "";
  const goldNetWeight = filterValues?.["Gold Net-Weight"]?.length > 0 ? filterValues["Gold Net-Weight"] : "";
  const ratio = filterValues?.["Ratio"]?.length > 0 ? filterValues["Ratio"] : "";

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isError, error } = useStockDesings({
    limit: 30,
    categoryName,
    subCategoryName,
    sortBy: selectedSortBY,
    order: selectedSortOrder,
    searchTerm: search,
    location: Location,
    stockStatus,
    goldColor,
    goldQlty: goldPurity,
    diaQlty: diamondQuality,
    designClass,
    isHidden: !isHidden,
    diamondPieces,
    diamondWeight,
    goldGrossWeight,
    goldNetWeight,
    ratio,
  });

  useEffect(() => {
    let allStockData = data?.pages?.flatMap((page) => page?.stockDesigns);
    setStockData(allStockData);
    if (search === "") {
      setDynamicFilterCount(true);
    }
    if (dynamicfilterCount) {
      setFilterChangeCount(data?.pages[0]?.totalSerachAndFilter);
      // setFilterChangeDesignCount(data?.pages[0]?.totalStyles);
      setSearchResultCount(data?.pages[0]?.totalSerachAndFilter);
    } else {
      setSearchResultCount(data?.pages[0]?.totalSerachAndFilter);
      setFilterChangeCount(filterChangeCount);
      // setFilterChangeDesignCount(filterChangeDesignCount);
    }
    setDisplayCount(true);
    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      // setFilterChangeDesignCount(0);
      setDisplayCount(false);
    };
  }, [data]);

  // console.log("cards", categoryName, subCategoryName);

  // useEffect(() => {

  //   // if (!location?.state?.name || location?.state?.name[1]?.includes("undefined")) {
  //   //   navigate(location?.pathname, {
  //   //     state: {
  //   //       name: [categoryName, subCategoryName],
  //   //     },
  //   //     replace: true,
  //   //   });
  //   // }

  // }, [data, location]);

  if (isLoading) return <ProductSkeleton count={10} />;
  if (isError) return <div>Error: {error?.message}</div>;

  const hasNoResults =
    search &&
    data?.pages?.every(
      (page) => !page?.stockDesigns?.length
    );

  if (hasNoResults) return <DataNotFound message={`No results found for "${search}"`} />;

  return (
    <>
      <InfiniteScroll
        dataLength={data?.pages.flatMap((page) => page.designs).length || 0}
        next={fetchNextPage}
        hasMore={hasNextPage}
        loader={isFetchingNextPage && <CircularProgress sx={{ display: "flex", justifyContent: "center", margin: "20px auto" }} />}
        scrollThreshold={0.8}
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          sx={{
            flex: "1 1 1",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "0px",
            rowGap: "0px",
          }}
          className="Grid-padding"
        >
          {data?.pages?.map((page) =>
            page.stockDesigns.map((design) => {
              return <Product product={design} key={design._id} allData={stockData} />;
            })
          )}
        </Grid>
      </InfiniteScroll>

      <GoToTop />

      {data?.pages?.length === 0 ||
        (!data?.pages.some((page) => page?.stockDesigns?.length > 0) && (
          <div
            style={{
              display: "flex",
              textAlign: "center",
              margin: "auto",
              padding: "auto",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          >
            <Background />
          </div>
        ))}
    </>
  );
};

export default Products;
